import React, { lazy, Suspense } from 'react'
import { useParams } from 'react-router-dom'
import Preloader from './Preloader'

const Content = lazy(() => import('./Content'))

type UrlParams = {
    code: string
}

function AssetPage() {
    const params = useParams<UrlParams>()
    const currencyCode = params.code?.toUpperCase() ?? ''

    return (
        <Suspense fallback={<Preloader />}>
            <Content currencyCode={currencyCode} />
        </Suspense>
    )
}

export default AssetPage
